import { render } from "./HardwareLegend.vue?vue&type=template&id=5d013195&scoped=true&ts=true"
import script from "./HardwareLegend.vue?vue&type=script&setup=true&lang=ts"
export * from "./HardwareLegend.vue?vue&type=script&setup=true&lang=ts"

import "./HardwareLegend.vue?vue&type=style&index=0&id=5d013195&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d013195"],['__file',"resources/js/vue/domain/admin/seg-frame-builder/HardwareLegend.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5d013195"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d013195', __exports__)) {
    api.reload('5d013195', __exports__)
  }
  
  module.hot.accept("./HardwareLegend.vue?vue&type=template&id=5d013195&scoped=true&ts=true", () => {
    api.rerender('5d013195', render)
  })

}


export default __exports__